module.exports = __webpack_public_path__ + "media/images/meetAnna-adolescent-7cf450c1d4fc656684a9b669d072e7c3.svg";